import LocalizedStrings from "react-localization";
import { Grid } from "@aws-amplify/ui-react";
import { useState } from "react";

import { ScheduleProvider } from "components/maintenanceSchedules/context/ScheduleContext";
import ScheduleBoard from "components/maintenanceSchedules/ScheduleBoard";
import CompanyBranchFilter from "components/companies/CompanyBranchFilter";

const MaintenanceSchedules = () => {
  const [searchBy, setSearchBy] = useState({
    company: {
      id: "",
      display: "",
    },
    branch: {
      id: "",
      display: "",
    },
  });

  return (
    <ScheduleProvider
      branchID={searchBy.branch.id}
      companyID={searchBy.company.id}
    >
      <span className="fs-3">{strings.title}</span>
      <div className="py-3">
        <Grid
          className="mb-3"
          templateColumns={{ medium: "1fr", xl: "1fr 1fr 1fr" }}
          rowGap="15px"
          columnGap="15px"
        >
          <CompanyBranchFilter searchBy={searchBy} setSearchBy={setSearchBy} />
        </Grid>
        <ScheduleBoard />
      </div>
    </ScheduleProvider>
  );
};

const strings = new LocalizedStrings({
  es: {
    title: "Programación de Mantenimiento",
  },
});

export default MaintenanceSchedules;
